
















































































import {Vue, Component} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import {CreditCard} from '@/components/CreditCard';
import {objectToQuerystring} from '@/services/api';

@Component({
  name: 'PaymentTile',
  components: {
    CreditCard,
  },
  beforeCreate() {
    (this as any).urlOrderNumber = this.$route.query.order_number;
  },
  updated() {
    (this as any).updateLink();
  },
  mounted() {
    if (this.$refs.errorText) {
      (this as any).updateLink();
    }
  },
  beforeDestroy() {
    if (this.linkToCatalog) {
      this.linkToCatalog.removeEventListener('click', (this as any).routToLink);
    }
  },
  props: {
    payError: {
      type: String,
      default: '',
    },
    currency: {
      type: String,
      default: '',
    },
    actualCard: {
      type: Object,
      default: () => {},
    },
    actualAmount: {
      type: Number,
      default: 0,
    },
    actualPaymentId: {
      type: String,
      default: '',
    },
    actualPaymentInfo: {
      type: Object,
      default: () => {},
    },
    hasError: {
      type: Object,
      default: () => {},
    },
    withoutBackBtn: {
      type: Boolean,
      default: false,
    },
    disableBtn: {
      type: Boolean,
      default: false,
    },
    showCircular: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      urlOrderNumber: '',
      tokenData: null,
      linkToCatalog: document.getElementById('foreign_catalog'),
    };
  },
  computed: {
    ...mapGetters(['paymentTexts']),
    ...mapGetters(['actualSearchData']),
    actualCurrency() {
      return this.currency ? this.currency.toLowerCase() : this.paymentTexts.currency;
    },

    linkToCatalogHref(): {} {
      const objForQuery = {...this.actualSearchData, ...{foreign_card: 'True'}};
      if (Array.isArray(this.actualSearchData.rooms)) {
        (objForQuery as any).rooms = this.actualSearchData.rooms.join();
      }
      return objForQuery;
    },
  },
  methods: {
    updateLink() {
      this.linkToCatalog = document.getElementById('foreign_catalog');
      if (this.linkToCatalog) {
        const { href } = this.$router.resolve({name: 'catalog', query: (this as any).linkToCatalogHref});
        (this.linkToCatalog as HTMLAnchorElement).href = href;
        this.linkToCatalog.addEventListener('click', this.routToLink);
      }
    },

    routToLink() {
      const objForQuery = {...this.actualSearchData, ...{foreign_card: 'True'}};
      if (Array.isArray(this.actualSearchData.rooms)) {
        (objForQuery as any).rooms = this.actualSearchData.rooms.join();
      }
      this.$router.push({name: 'catalog', query: (objForQuery as any)});
    },
  },
})
export default class PaymentTile extends Vue {
}
